module.exports = __webpack_public_path__ + "static/media/CHesterAlmondine.c5eceace.jpeg";